import { fetchJsonResponse } from '@/ai/api'
import { buildDescriptionValidatorPrompt } from '@/ai/prompts'

export const validateWorkflowDescription = async ({ workflow, attachments, abortController }) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildDescriptionValidatorPrompt({ workflow, attachments })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'workflow-diagram',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
